<app-top-bar></app-top-bar>

<ng-container *ngIf="omnisearchData$ | async as ob">
  <div [style.display]="ob.omnisearchFocused ? 'none' : 'block'">
    <router-outlet></router-outlet>
  </div>

  <app-omnisearch-results-container *ngIf="ob.omnisearchFocused" [showClose]="showClose"
    [results]="ob.omnisearchResults" [searchType]="ob.queryType" [recommendedExperts]="ob.recommendedExperts"
    [viewedOpportunityName]="ob.omnisearchProjectName">
  </app-omnisearch-results-container>
</ng-container>